import { 商品区分型 } from '@/type/master/item';
import { Validator } from '@/type/validation/result';
import {半角カナ禁止, 必須入力, 日付書式} from '@/type/validation/validator';

export interface 入庫履歴照会依頼型 {
  メーカー名: string | null;
  商品名カナ: string | null;
  入庫日From: Date;
  入庫日To: Date | null;
  商品区分: 商品区分型 | null;
  卸コード: string | null;
  部署コード: string | null;
  登録者コード: string;
}

export interface 入庫履歴照会型 {
  入庫日: Date;
  卸コード: string;
  卸名: string;
  伝票番号: string;
  伝票行番号: number;
  商品区分: 商品区分型;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  入庫数: number;
  有効期限: Date;
  ロット番号: string;
  入庫遡及対象外区分: 入庫遡及対象外区分型;
  箱単価: number;
  合計金額: number;
  包装薬価: number;
  薬価金額: number;
  差額: number;
  利用者氏名: string;
  部署名: string;
}

export interface 入庫履歴照会結果型 {
  入庫履歴一覧: 入庫履歴照会型[];
  アラートメッセージ: string;
}

export enum 入庫遡及対象外区分型 {
  対象 = '対象',
  対象外 = '対象外',
}

export const 検索条件バリデータ一覧: Validator[] = [
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
  {
      name: '入庫日From',
      constraints: [
          {method: 必須入力, message: '入庫日Fromは入力必須項目です'},
          {method: 日付書式, message: '入庫日Fromの書式が不正です'},
      ],
  },
  {
      name: '入庫日To',
      constraints: [
        {method: 日付書式, message: '入庫日Toの書式が不正です'},
      ],
  },
];
